import { createContext, FC, PropsWithChildren, useEffect, useState } from "react";
import axios from "../api/axios";
import SelectOption from "../@types/SelectOption";

interface CurrencyConverterContxt {
    locale: string;
    setLocale: React.Dispatch<React.SetStateAction<string>>;
    currency: string;
    setCurrency: React.Dispatch<React.SetStateAction<string>>;
    formatter: Intl.NumberFormat;
    convertCurrency: (value: number) => string;
    currencyOptions: SelectOption[];
}

const CurrencyConverterContext = createContext<CurrencyConverterContxt | undefined>(undefined);

interface ExchangeRateData {
    pk: string,
    date: string,
    rate: number
}

const currencyOptions: SelectOption[] = [
    { label: 'United States - $', value: 'USD' },
    { label: 'Europe - €', value: 'EUR' },
    { label: 'UK - £', value: 'GBP' }
  ];

export const CurrencyConverterProvider: FC<PropsWithChildren> = ({ children }) => {
    const defaultCurrency = process.env.REACT_APP_CART_CONFIGURATOR_DEFAULT_CURRENCY ?? 'USD';

    useEffect(() => {
        /* Pull exchange rate data via API */
        const getExchangeRateData = async() => {
            try {
                const response = await axios.get('/exchange-rates');
                const data = response.data.data as ExchangeRateData[];
                setExchangeRateData(data);
            } catch (error) {
                console.log(error);
            }
        }
        getExchangeRateData();
    }, []);

    const [locale, setLocale] = useState<string>('en-US');
    const [currency, setCurrency] = useState<string>(defaultCurrency);
    const [formatter, setFormatter] = useState<Intl.NumberFormat>(Intl.NumberFormat(locale, { style: 'currency', currency: currency }));
    const [activeExchangeRate, setActiveExchangeRate] = useState<number>(1);
    const [exchangeRateData, setExchangeRateData] = useState<ExchangeRateData[]>([]);
    

    useEffect(() => {
        setFormatter(Intl.NumberFormat(locale, { style: 'currency', currency: currency }));
        const rate: ExchangeRateData | undefined = exchangeRateData?.find((data) => data.pk === currency);
        setActiveExchangeRate(currency !== 'USD' ? rate?.rate ?? 1 : 1);
    }, [exchangeRateData, currency]);

    const convertCurrency = (value: number): string => {
        return formatter.format(Math.ceil(value * activeExchangeRate));
    }

    return (
        <CurrencyConverterContext.Provider
            value={{
                currency,
                setCurrency,
                locale,
                setLocale,
                formatter,
                convertCurrency,
                currencyOptions,
            }}>
            {children}
        </CurrencyConverterContext.Provider>
    )
}

export default CurrencyConverterContext